export default class Business {
  /**
   * Create new business and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * Search and match the string on urls to create a list of separate urls
   *
   * @return {Array}
   */
  get businessUrls () {
    return this.businessUrl ? this.businessUrl.match(/(?:https?:\/\/)?[\w/\-?=%.]+\.[\w/\-?=%.]+/igm) : []
  }
}
